// formatTimeString("14:30:00") -> "14:30"
// formatTimeString("09:05:30") -> "09:05"
export const formatTimeString = (time, separator = ':') => {
    const [hours, minutes] = time.split(separator);
    return `${hours}${separator}${minutes}`;
};
